// extracted by css-extract-rspack-plugin
export default {"disabled":"CreateSavedView-module__disabled__yfwnI"};